<div *ngIf="message">
  <ami-dialog-message [setting]="message"></ami-dialog-message>
</div>

<div class="card">
  <div class="flex justify-content-center">
    <div class="grid flex align-items-center justify-content-center">
      <form [formGroup]="fg">
        <div class="col-12 md:col-11">
          <span class="block text-3xl font-medium text-900 mt-2"
            >Inventariar
          </span>
          <div class="field col-12">
            <p-message
              severity="info"
              text="Registre los productos en su stock-sucursal a partir del almacén, Asegurese de ingresar los datos correctamente."
              styleClass="p-mr-2"
            ></p-message>
          </div>
        </div>
        <div class="col-12 md:col-12 mb-4">
          <pg-branch-store-details
            (onSelect)="onSelectedBranchStore($event)"
            [legend]="branchStoreSelected.legend"
          ></pg-branch-store-details>
        </div>

        <div class="grid">
          <div class="col-6 md:col-6">
            <p-fieldset legend="Producto del almacén" [toggleable]="false">
              <div class="formgrid grid">
                <div class="field col-12 md:col-11">
                  <label>Producto del almacén</label>
                  <input
                    formControlName="productOfWarehouse"
                    pInputText
                    type="text"
                    class="inputfield w-full"
                    readonly
                  />
                </div>
                <div class="field col-12 md:col-1 mt-4">
                  <button
                    type="button"
                    pButton
                    pRipple
                    (click)="select.productOfWarehouse.openDialog = true"
                    icon="pi pi-plus"
                    class="p-button-rounded p-button-info"
                    pTooltip="Seleccionar producto del almacén"
                    tooltipPosition="left"
                  ></button>
                </div>
              </div>
              <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-5 md:mb-0 mt-2">
                  <label>Cantidad: </label>
                </div>
                <div class="field col-12 md:col-7">
                  <p-inputNumber
                    formControlName="quantityProductOfWarehouse"
                    [showButtons]="true"
                  >
                  </p-inputNumber>
                  <div
                    *ngIf="
                      fg.get('quantityProductOfWarehouse').invalid &&
                      (fg.get('quantityProductOfWarehouse').dirty ||
                        fg.get('quantityProductOfWarehouse').touched)
                    "
                    class="p-invalid"
                  >
                    <div
                      *ngIf="
                        fg.get('quantityProductOfWarehouse').errors?.required
                      "
                    >
                      <small class="p-error">No puede quedar vacio.</small>
                    </div>
                    <div
                      *ngIf="fg.get('quantityProductOfWarehouse').errors?.min"
                    >
                      <small class="p-error"
                        >Debe tener un valor minimo de 1.</small
                      >
                    </div>
                    <div
                      *ngIf="fg.get('quantityProductOfWarehouse').errors?.max"
                    >
                      <small class="p-error"
                        >Debe tener un valor maximo de
                        {{ quantityWarehouseMax }}.</small
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-5 md:mb-0">
                  <label>Unidades en {{ unitMeasureWarehouse }}: </label>
                </div>
                <div class="field col-12 md:col-7">
                  <p-inputNumber
                    formControlName="unitsInProductWarehouse"
                    [showButtons]="true"
                  >
                  </p-inputNumber>
                  <div
                    *ngIf="
                      fg.get('unitsInProductWarehouse').invalid &&
                      (fg.get('unitsInProductWarehouse').dirty ||
                        fg.get('unitsInProductWarehouse').touched)
                    "
                    class="p-invalid"
                  >
                    <div
                      *ngIf="fg.get('unitsInProductWarehouse').errors?.required"
                    >
                      <small class="p-error">No puede quedar vacio.</small>
                    </div>
                    <div *ngIf="fg.get('unitsInProductWarehouse').errors?.min">
                      <small class="p-error"
                        >Debe tener un valor minimo de 1.</small
                      >
                    </div>
                  </div>
                </div>
              </div>
            </p-fieldset>
          </div>
          <div class="col-6">
            <p-fieldset legend="Producto" [toggleable]="false">
              <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-4">
                  <label
                    >Cantidad Total del tipo {{ unitMeasureProduct }}</label
                  >
                </div>
                <div class="field col-12 md:col-6">
                  <input
                    type="text"
                    pInputText
                    formControlName="equivalentQuantity"
                    readonly
                  />
                </div>
              </div>
              <div class="field col-12">
                <p-message
                  severity="warn"
                  text="Verificar la cantidad de productos que ingresan al stock."
                  styleClass="p-mr-2"
                ></p-message>
              </div>
            </p-fieldset>
          </div>
        </div>
        <div class="flex justify-content-center card-container mt-3">
          <button
            (click)="onSubmit()"
            pButton
            pRipple
            class="p-button-sg p-button-success"
            pTooltip="Confirmar operación"
            tooltipPosition="left"
            [disabled]="fg.invalid || !isBranchStoreSelected"
          >
            CONFIRMAR OPERACIÓN
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<pg-warehouse-product-select
  *ngIf="select.productOfWarehouse.openDialog"
  (selectedRowsEvent)="onSelectedproductOfWarehouse($event)"
>
</pg-warehouse-product-select>
